(function () {
  const STORAGE_KEY = 'fv-collection-view';

  function applyView(view) {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    grid.classList.toggle('list-view', view === 'list');

    document.querySelectorAll('.collection__view-btn').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.view === view);
    });
  }

  function savedView() {
    return localStorage.getItem(STORAGE_KEY) || 'grid';
  }

  function initToggle() {
    applyView(savedView());

    document.querySelectorAll('.collection__view-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const view = btn.dataset.view;
        localStorage.setItem(STORAGE_KEY, view);
        applyView(view);
      });
    });

    // Re-apply after facet filtering AJAX re-renders the grid
    const container = document.getElementById('ProductGridContainer');
    if (container) {
      new MutationObserver(() => applyView(savedView())).observe(container, {
        childList: true,
        subtree: false,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToggle);
  } else {
    initToggle();
  }
})();
